<template>
  <div class="umi-order">
    <legend :title="order.RecastNumber" v-if="order.RecastNumber === 0">Заказ
      №{{order.SferaNumber}}
    </legend>
    <legend :title="order.RecastNumber" v-else>Переделка заказа №{{order.SferaNumber}}</legend>


    <div class="mt-3">
      <div class="form-group row">
        <div class="col-lg-6">
          <label>Клиент</label>
          <customer-select :order-id="order.Id" @customer-change="setCustomer"></customer-select>
          <!--                    <input type="text" class="form-control form-control-sm" v-model="customer.Reception" readonly>-->
        </div>
        <div class="col-md-4 col-lg-2">
          <label>Объезд</label>
          <input :value="customer.Tour.Name" class="form-control form-control-sm" readonly
                 type="text">
        </div>
        <div class="col-md-4 col-lg-2">
          <label>Дни отправки</label>
          <input :value="clientSDays" class="form-control form-control-sm" readonly type="text">
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="required">Форма оплаты</label>
          <payment-type-select :payment-type-id="order.PaymentTypeId"
                               @payment-type-change="setPaymentType"></payment-type-select>
          <!--          <input type="text" class="form-control form-control-sm" v-model="order.PaymentType.Name" readonly>-->
        </div>
      </div>
      <div class="form-group row">
        <div class="col-lg-12">
          <label>Название заказа</label>
          <input class="form-control form-control-sm" readonly type="text" v-model="order.Name">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-lg-6">
          <label>Артикул</label>
          <input class="form-control form-control-sm" readonly type="text" v-model="order.Name">
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="required">Цена</label>
          <input autocomplete="disable" class="form-control form-control-sm" required type="number"
                 :disabled="!$auth.check(['admin'])"
                 v-model="order.Summary"
                 v-on:keydown.enter.prevent>
        </div>
        <div class="col-md-4 col-lg-2">
          <label class="required">Количество</label>
          <input autocomplete="disable" class="form-control form-control-sm" min="1" required
                 type="number"
                 v-model="order.Amount" v-on:keydown.enter.prevent>
        </div>
        <!--                <div class="col-md-4 col-lg-2">-->
        <!--                    <label class="required">Сумма за заказ</label>-->
        <!--                    <input type="number" class="form-control form-control-sm" v-model="order.Summary" required readonly-->
        <!--                           autocomplete="disable" v-on:keydown.enter.prevent>-->
        <!--                </div>-->
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label>От клиента</label>
          <div>
            <date-picker :disabled="false" :first-day-of-week="1" :format="momentFormat"
                         class="w-100"
                         lang="ru"
                         v-model="order.CustomerDate" valueType="format"></date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <label>Дата готовности</label>
          <div>
            <date-picker :disabled="false" :first-day-of-week="1" :format="momentFormat"
                         :input-attr="{required: true}"
                         class="w-100"
                         lang="ru"
                         v-model="order.ReadyDate" valueType="format"></date-picker>
          </div>
        </div>

      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label>Дата оплаты</label>
          <div>
            <date-picker :disabled="false" :first-day-of-week="1" :format="momentFormat"
                         class="w-100"
                         lang="ru"
                         v-model="order.PaidDate" valueType="format"></date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <label>Дата получения</label>
          <div>
            <date-picker :disabled="false" :first-day-of-week="1" :format="momentFormat"
                         :input-attr="{required: true}"
                         class="w-100"
                         lang="ru"
                         v-model="order.PassedDate" valueType="format"></date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <label>Статус</label>
          <div>
            <div class="dropdown">
              <button aria-expanded="false"
                      aria-haspopup="true" class="btn btn-info dropdown-toggle btn-sm btn-block"
                      data-toggle="dropdown" id="dropdownMenuButton" type="button">
                {{getStatusNameById(order.OrderStatusId)}}
              </button>
              <div class="dropdown-menu">
                <h6 class="dropdown-header">Изменить статус</h6>
                <a @click.prevent="order.OrderStatusId = status.Id" class="dropdown-item" href="#"
                   v-for="status in allowedStatuses">{{status.Name}}</a>
                <!--                <h6 class="dropdown-header">Операции</h6>-->
                <!--                <a class="dropdown-item" href="#" @click.prevent="partPaid(order.Order.Id)">Оплачен частично</a>-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label>Дата отправки</label>
          <div>
            <date-picker :disabled="false" :first-day-of-week="1" :format="momentFormat"
                         :input-attr="{required: true}"
                         class="w-100"
                         lang="ru"
                         v-model="order.DispatchDate" valueType="format"></date-picker>
          </div>
        </div>
        <div class="col-md-3" v-show="deliveryMeta.DeliveryDate">
          <label>Ссылка на доставку</label>
          <div>
            <router-link :to="{ name: 'print-delivery', query: { time: deliveryMeta.DeliveryDate, panelUserId: deliveryMeta.PanelUserId }}"
                         class="btn btn-outline-secondary btn-block btn-sm">
              Ссылка на доставку
            </router-link>
          </div>
        </div>

      </div>
      <div class="form-group row">
        <div class="col-md-12 col-lg-6">
          <label>Примечание</label>
          <textarea class="form-control form-control-sm" cols="30" rows="3"
                    v-model="order.Comment"></textarea>
        </div>
        <div class="col-md-6 col-lg-3">
          <label>Номер клиента</label>
          <input class="form-control form-control-sm" type="text" v-model="order.LocalNumber"
                 v-on:keydown.enter.prevent
          >
        </div>
        <div class="col-md-6 col-lg-3">
          <label class="required">Номер сферы</label>
          <input class="form-control form-control-sm" readonly required
                 type="number"
                 v-model="order.SferaNumber"
                 v-on:keydown.enter.prevent>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import moment from 'moment';
import { get, put } from '@/admin/services/api/http-utils';
import api from '@/admin/modules/Customer/api';
import CustomerSelect from '@/admin/modules/Order/_components/CustomerSelect.vue';
import PaymentTypeSelect from '@/admin/modules/Order/_components/PaymentTypeSelect.vue';

const masterCustomer = {
  Reception: '',
  Tour: {
    Name: null,
  },
};
const url = `${process.env.VUE_APP_API_HOST}admin/order`;
export default {
  components: {
    DatePicker,
    CustomerSelect,
    PaymentTypeSelect,
  },
  props: ['id', 'type'],
  data() {
    return {
      recastRecastMessage: '',
      customer: _.cloneDeep(masterCustomer),
      deliveryMeta: [],
      order: {
        PaymentType: {
          Name: '',
        },
      },
      statuses: [],
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
    };
  },
  async beforeMount() {
    await this.fetchOrder();
    await this.fetchStatuses();
    await this.fetchDeliveryMeta();
  },
  computed: {
    clientSDays() {
      if (!this.customer || !this.customer.CustomerDispatchDays) {
        return '';
      }
      const SDays = this.customer.CustomerDispatchDays.map(item => item.ShortName);

      return SDays.join(', ');
    },
    allowedStatuses() {
      return this.statuses;
      // return _.filter(this.statuses, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
  },
  watch: {
    async order() {
      if (!_.isEmpty(this.order)) {
        const { data } = await api.fetchCustomer(this.order.CustomerId);
        this.customer = data;
        console.log(this.customer);
      } else {
        this.customer = _.cloneDeep(masterCustomer);
      }
    },
    'order.Summary': function (newVal) {
      this.updateOrder({ Summary: newVal });
    },
    'order.Amount': function (newVal) {
      this.updateOrder({ Amount: newVal });
    },
    'order.CustomerDate': function (newVal) {
      this.updateOrder({ CustomerDate: newVal });
    },
    'order.ReadyDate': function (newVal) {
      this.updateOrder({ ReadyDate: newVal });
    },
    'order.PaidDate': function (newVal) {
      this.updateOrder({ PaidDate: newVal });
    },
    'order.PassedDate': function (newVal) {
      this.updateOrder({ PassedDate: newVal });
    },
    'order.OrderStatusId': function (newVal) {
      this.updateOrder({ OrderStatusId: newVal });
    },
    'order.LocalNumber': function (newVal) {
      this.updateOrder({ LocalNumber: newVal });
    },
    'order.DispatchDate': function (newVal) {
      this.updateOrder({ DispatchDate: newVal });
    },
    'order.Comment': function (newVal) {
      this.updateOrder({ Comment: newVal });
    },
  },
  methods: {
    async fetchStatuses() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.statuses = data.data;// _.filter(data.data, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
    async fetchOrder() {
      const { data } = await get(`${url}/${this.id}`);
      this.order = data;
      // this.customer = data.customer;
      // this.orderPaymentType = data.orderPaymentType;
      // this.partnerTour = data.partnerTour;
    },
    async fetchDeliveryMeta() {
      const { data } = await get(`${url}/${this.id}/delivery-meta`);
      this.deliveryMeta = data;
      // this.customer = data.customer;
      // this.orderPaymentType = data.orderPaymentType;
      // this.partnerTour = data.partnerTour;
    },

    async setCustomer(customerId) {
      if (customerId && this.order.CustomerId !== customerId) {
        // const orderItem = Object.assign({}, { Id: this.order.Id }, {
        //   CustomerId: customerId,
        // });
        await this.updateOrder({
          CustomerId: customerId,
        });
      }
    },
    async setPaymentType(PaymentTypeId) {
      console.log('PaymentTypeId', PaymentTypeId, this.order.PaymentTypeId);
      if (PaymentTypeId.PaymentTypeId && this.order.PaymentTypeId !== PaymentTypeId.PaymentTypeId) {
        // const orderItem = Object.assign({}, { Id: this.order.Id }, {
        //   CustomerId: customerId,
        // });
        await this.updateOrder(PaymentTypeId);
      }
    },
    async updateOrder(orderItemData) {
      try {
        const orderItem = Object.assign({}, { Id: this.order.Id }, orderItemData);
        await put(url, { orderItem });
      } catch (e) {
        let message = 'Неизвестная ошибка';
        if (e.response.data) {
          message = e.response.data;
        }
        this.$toasted.show(message, { type: 'error' });
      }

      // await this.fetchOrder();
    },
    getStatusNameById(statusId) {
      // console.log(this.statuses, statusId)
      const status = _.find(this.statuses, o => o.Id === statusId);
      // console.log(status)
      return status ? status.Name : '';
      // return status.Name;
    },
  },
};
</script>
